export enum FsContactAttachmentTypeEnum {
  Video = 1,
  SupportingDocument = 2
}
